import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import DateInput from 'components/DateInput';
import {ErrorField, WarningField} from 'components/Fields';

import './styles.css';

const DateField = ({
  meta: {error, warning},
  input: {value, onChange, name, onBlur},
  placeholder,
  className,
  fieldWarning,
  disabled,
  dayPickerProps,
  onDateChange,
  overlayComponent
}: any) => {
  // This will be removed when we decide which warning scheme to use
  const warningToDisplay = warning || fieldWarning;
  const classNameProp = classNames(
    {error, warning: warningToDisplay},
    className
  );

  return (
    <div className="DateField">
      <DateInput
        className={classNameProp}
        placeholder={placeholder}
        disabled={disabled}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        name={name}
        dayPickerProps={dayPickerProps}
        onDateChange={onDateChange}
        overlayComponent={overlayComponent}
      />
      <ErrorField touched={true} error={error} />
      <WarningField touched={true} warning={warningToDisplay} />
    </div>
  );
};

export default DateField;
